export default {
  rate_us: "Rate us & get free menu items",
};
